import { isArray, isNumber, isString, isUndefined } from 'lodash-es';

import { DEFAULT_TILE_NAME } from '../constants.js';
import { HoneycombTileData } from '../types/honeycomb.js';

/**
 * Normalizes a tile providing a default name if needed.
 *
 * @param data - the Honeycomb tile dta
 * @param index - the current tile index
 */
const normalizeTile = (
  data: string | number | HoneycombTileData,
  index?: number,
) => {
  const isOnlyValue = isString(data) || isNumber(data);
  const value = isOnlyValue ? data : data.value;

  let name = '';

  if (isOnlyValue || !data.name) {
    name = `${DEFAULT_TILE_NAME}`;

    if (index !== undefined) {
      name += `-${index + 1}`;
    }
  } else {
    name = data.name;
  }

  return {
    ...(isOnlyValue ? {} : data),
    value,
    name,
  } as HoneycombTileData;
};

/**
 * Normalizes an array of Honeycomb tiles, providing a name where not present
 * @param data - the Honeycomb input data
 */
export const normalizeTilesData = (
  data: string | number | string[] | number[] | HoneycombTileData[],
): HoneycombTileData[] => {
  const dataArray = isArray(data) ? data : [data];
  const normalizedData: HoneycombTileData[] = [];

  dataArray.forEach((item, index) => {
    const nameIndex = dataArray.length > 1 ? index : undefined;
    const normalizedTile = normalizeTile(item, nameIndex);
    if (!isUndefined(normalizedTile.value)) {
      normalizedData.push(normalizedTile);
    }
  });

  return normalizedData;
};
